"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.noopDetector = exports.NoopDetector = void 0;
class NoopDetector {
    detect() {
        return {
            attributes: {},
        };
    }
}
exports.NoopDetector = NoopDetector;
exports.noopDetector = new NoopDetector();
//# sourceMappingURL=NoopDetector.js.map